<template>
  <div class="page-templates">
    <PageHeader>
      <h1>Site Templates</h1>

      <Btn primary>
        <router-link :to="{name: 'add-template'}">
          Add Template
        </router-link>
      </Btn>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <table-data
            :rows="templates"
            :headings="[{heading: 'Template Name', key: 'template-name'}]"
            :pagination="pagination"
          >
            <div
              v-for="(template, index) in templates"
              :slot="'td-' + index + '-template-name'"
              :key="index"
            >
              <router-link
                :to="{name: 'template', params: {templateId: template.id}}"
              >
                {{ template.name }}
              </router-link>
            </div>
          </table-data>

          <pagination @changePage="changePage" :pagination="pageData">
          </pagination>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Templates</h1>
            <p>
              User can select a site template when creating a new website. A
              template is actually an occupation, such as a
              <strong>plumber</strong>.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readTemplatesData} from '@/lib/templates'

import Table from '@/components/Table'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Btn from '@/components/Btn'

export default {
  name: 'templates',

  mixins: [page, pagination],

  components: {
    TableData: Table,
    PageHeader,
    PageSummary,
    Btn
  },

  data() {
    return {
      templates: [],
      errors: {},
      title: 'Templates'
    }
  },

  methods: {
    getData() {
      readTemplatesData().then(({data}) => {
        this.templates = data
        this.pageData = page
      })
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-templates
  @extend %page
</style>
